import { Provider } from 'react-redux';

import { LOCALES } from '~/shared/constants';
import store from '~/shared/store';

const withStorage = (WrappedComponent) => {
  return (props) => {
    return (
      <Provider store={store}>
        <WrappedComponent params={{ lng: props?.lng ?? LOCALES.UA }} {...props} />
      </Provider>
    );
  };
};

export default withStorage;
